import * as React from "react";
import * as Lodash from "lodash";
import classnames from "classnames";

/**
 * Progress bar for the checkout application
 */

const Classes = {
  active: "active",
  disable: "disable",
  last: "last",
};

interface Props {
  model: Model;
  onChange: (Tab) => void;
  haveTotalAmount?: boolean;
}

export function Progress(
  {
    onChange, haveTotalAmount, model
  }:Props) {

  const onClick = (tab: TabKey) => {
    !isDisabled(tab) && onChange(Tab[tab]);
  };

  const isActive = (tab: TabKey): boolean => {
    return model.active === Tab[tab];
  }

  const isDisabled = (tab: TabKey): boolean => {
    return !Lodash.isNil(model.disabled.find(t => t === Tab[tab]));
  }

  const className = (tab: TabKey): string => {
    return isActive(tab) ? Classes.active : isDisabled(tab) ? Classes.disable : "";
  }

  return (
    <div className="progress-steps">
      <ul>
        {(Object.values(Tab) as Array<keyof typeof Tab>).filter(v => isNaN(v as any)).map((key,index,self) =>
          <li key={key} className={classnames(className(key), index === self.length - 1 && Classes.last)}>
            <a aria-current={isActive(key) ? 'true' : 'false'} onClick={() => onClick(key)} href="#">
              {key === 'Payment' ? haveTotalAmount ? 'Payment' : 'Confirmation' : key}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}


export enum Tab {
  Details,
  Summary,
  Payment,
}

export type TabKey = keyof typeof Tab;

export interface Model {
  active: Tab;
  disabled: Tab[];
}

